// PortugalPRPage.js
import React from 'react';
import PRHero from '../components/PermanentResidency/Portugal/PRHero';
import WhyPortugalPR from '../components/PermanentResidency/Portugal/WhyPortugalPR';
import PRPathways from '../components/PermanentResidency/Portugal/PRPathways';
import EligibilityRequirements from '../components/PermanentResidency/Portugal/EligibilityRequirements';
import ProcessTimeline from '../components/PermanentResidency/Portugal/ProcessTimeline';
import PRPricing from '../components/PermanentResidency/Portugal/PRPricing';
import PRFAQSection from '../components/PermanentResidency/Portugal/PRFAQSection';
import PRCTASection from '../components/PermanentResidency/Portugal/PRCTASection';

const PortugalPRPage = () => {
  return (
    <div>
      <PRHero />
      <WhyPortugalPR />
      <PRPathways />
      <EligibilityRequirements />
      <ProcessTimeline />
      <PRPricing />
      <PRFAQSection />
      <PRCTASection />
    </div>
  );
};

export default PortugalPRPage;
